/**
 * Полезные утилиты
 */
export namespace Utils {

    /**
     * Глубокая проверка вложенных свойств
     * @param obj
     * @param valuePath
     */
    export const deepIf = (obj: object, valuePath: string): boolean => {
        const props = valuePath.split('.');

        if (!props.length) {
            return false;
        }

        let objToCheck = obj;

        return props.every((prop) => {
            return objToCheck.hasOwnProperty(prop) && (objToCheck = objToCheck[prop]);
        });
    };

    /**
     * Получение свойства из глубины объекта
     * deepGet(someObject, 'prop1.prop2.targetProp') => the value of targetProp inside prop2 inside prop1 inside someObject
     * @param obj
     * @param valuePath
     */
    export const deepGet = (obj: object, valuePath: string): any => {
        if (!valuePath || !obj) {
            return;
        }

        const props = valuePath.split('.');

        if (!props.length) {
            return;
        }

        let value = obj;

        const finished = props.every((prop, index) => {
            return value.hasOwnProperty(prop) && (value = value[prop]);
        });

        return finished && value || undefined;
    };

    export const objectValues = (obj: object): any[] => {
        if (!obj || typeof obj !== 'object') {
            return [];
        }

        return Object.keys(obj).map(key => obj[key]);
    };
}
